export default __webpack_public_path__ + "img/login.f90bfdb6331f4b1b5ba7565788743930.svg";